module.exports = __webpack_public_path__ + "static/assets/2d98ba28d4cb8ad599b1251958d574d6.jpg";